import { IBreadcrumb } from "@/study-search/interfaces/breadcrumb.interface";
import { Filter } from "@/study-search/models/filter/Filter";
import store from "@/study-search/store";
import { computed, Ref } from 'vue';
import { FilterKey } from '@studyportals/search-filters/server-side';
import { BreadcrumbsFactory } from "@/study-search/domain/BreadcrumbsFactory";

export default class BreadCrumb {
	url = computed(() => BreadcrumbsFactory.constructHref(this.breadcrumb.value));

	constructor(public breadcrumb: Ref<IBreadcrumb>) {}

	async onBreadcrumbClick(): Promise<void> {
		if (this.breadcrumb.value.isFirst) {
			window.location.href = '/';
			return;
		}
		const accumulatedFilters = this.breadcrumb.value?.accumulatedFilters;
		const filters = accumulatedFilters ? accumulatedFilters : [];
		if (filters.length > 0) {
			await this.clearOtherFilters(filters);
		} else {
			await store.actions.clearFilters();
		}
	}

	private async clearOtherFilters(currentFilters: Filter[]): Promise<void> {
		const allFilters = store.getters.getFilters();
		const filtersToClear = allFilters.filter((filter) => this.clearFiltersCondition(filter, currentFilters));
		await store.actions.clearFilterValues(
			filtersToClear.map((filter) => ({
				key: filter.key,
				value: filter.values[0]
			}))
		);
	}

	private clearFiltersCondition(filter: Filter, currentFilters: Filter[]): boolean {
		return (
			!currentFilters.some((currentFilter) => currentFilter.key === filter.key) &&
			filter.key !== FilterKey.KEYWORD_WHAT &&
			filter.key !== FilterKey.KEYWORD_WHERE
		);
	}
}